import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { EXTERNAL_ROUTES, PORTAL_ROUTE_PREFIX } from '../../constants/values';
var HomePage = function (props) {
    var isAdmin = props.isAdmin;
    var history = useHistory();
    React.useEffect(function () {
        if (!isAdmin) {
            window.location.href = EXTERNAL_ROUTES.BENEFITS_PAGE;
            return;
        }
        history.push(PORTAL_ROUTE_PREFIX + "/admin");
    }, [history, isAdmin]);
    return null;
};
export default HomePage;
